<template>
  <div>
    <div class="ux-upload-image">
      <span v-if="!preview">
        <button type="button" class="flush-left clear" @click="onPickFile">
          <i class="material-icons">backup</i>
          Upload
        </button>
        <input type="file" class="input-file" ref="file" @change="onFilePicked">
      </span>
      <span v-else>
        <div class="image-meta-data">
          <img :src="preview">
          <input type="text" v-model="filetitle">
          <input type="text" v-model="tags" id="tag">
          <button type="button" @click="doUpload">Go!</button>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["tag"],
  data() {
    return {
      preview: null,
      image: null,
      filename: null,
      filetitle: null,
      width: null,
      height: null,
      tags: null
    };
  },
  methods: {
    doUpload() {
      this.$store.dispatch("uploadImage", this.$data);
      this.preview = null;
    },
    onPickFile() {
      this.$refs.file.click();
    },
    onFilePicked(ev) {
      const preview = new FileReader();
      let files = ev.target.files;
      let that = this;

      this.image = files[0];
      this.filename = files[0].name;
      this.filetitle = this.fileToTitle(this.filename);

      if (this.tag) {
        this.tags = this.tag;
      } else {
        this.tags = "";
      }

      preview.addEventListener("load", () => {
        let img = new Image();
        img.onload = function() {
          that.width = this.width;
          that.height = this.height;
        };
        img.src = preview.result;
        this.preview = preview.result;
      });
      preview.readAsDataURL(this.image);
    },
    fileToTitle(str) {
      const letters = /^[0-9a-zA-Z]+$/;
      let arr, newarr, title;

      // Remove extention
      str = str
        .split(".")
        .slice(0, -1)
        .join(".");

      //Array of all str chars
      arr = Array.from(str);

      //Remove all non-alphanumerics
      newarr = arr.map(el => {
        return el.match(letters) ? el : " ";
      });

      // Create string from newarr
      title = newarr.join("");

      //Capitalize first letter of each word
      title = title
        .split(" ")
        .map(s => s.charAt(0).toUpperCase() + s.substring(1))
        .join(" ");

      return title;
    }
  }
};
</script>

<style lang="scss" scoped>
.image-meta-data {
  display: flex;
  align-items: center;
  margin: 0;
  button {
    margin-left: 0;
    margin-right: 0;
    justify-content: center;
  }
  @media only screen and (max-width: 660px) {
    flex-direction: column;
    button,
    input {
      width: 100%;
      height: inherit;
    }
    img {
      max-width: 100%;
    }
  }
}
.ux-upload-image {
  display: flex;
  align-items: center;

  img {
    max-width: 200px;
  }

  :last-child {
    flex: 1;
  }

  .input-file {
    display: none;
  }
  @media only screen and (max-width: 660px) {
    img {
      max-width: 100%;
      margin-bottom: 5px;
    }
  }
}
</style>

